import { APIModel } from './api-model.model'

export class APIReportDatasource extends APIModel {
    datasourceId: number;
    datasourceName: string;
    datasourceHost: string;
    datasourcePort: number;
    datasourceDatabase: string;
    datasourceUsername: string;
    datasourcePassword: string;
    datasourceEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        datasourceId: number;
        datasourceName: string;
        datasourceHost: string;
        datasourcePort: number;
        datasourceDatabase: string;
        datasourceUsername: string;
        datasourcePassword: string;
        datasourceEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.datasourceId = params.datasourceId
        this.datasourceName = params.datasourceName
        this.datasourceHost = params.datasourceHost
        this.datasourcePort = params.datasourcePort
        this.datasourceDatabase = params.datasourceDatabase
        this.datasourceUsername = params.datasourceUsername
        this.datasourcePassword = params.datasourcePassword
        this.datasourceEnabled = params.datasourceEnabled ? 1 : 0
    }
}
